import _ from "lodash";

const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const dateFormator = (timeStamp) => {
    const date = new Date(timeStamp)
    const Hours = date.getHours()>12?date.getHours()-12:date.getHours();
    const Minutes = date.getMinutes()
    const amOrPm = date.getHours()>12?"am":"pm"
    const resultDate = days[date.getDay()]+" "+date.getDate()+" "+months[date.getMonth()]+" "+date.getFullYear()
    return resultDate+" "+Hours+":"+Minutes+" "+amOrPm
}

export const convertToLocalTimeStamp = (timestamp, format) => {
    timestamp = Number(timestamp);
    var timestampInMilliSeconds = ((timestamp/1000).toFixed(0)) * 1000;
    var dateObj = new Date(timestampInMilliSeconds);
    var year = dateObj.getFullYear();
    var month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    var date = ("0" + dateObj.getDate()).slice(-2);
    var hours = ("0" + dateObj.getHours()).slice(-2);
    var minutes = ("0" + dateObj.getMinutes()).slice(-2);
    var seconds = ("0" + dateObj.getSeconds()).slice(-2);

    switch(format) {
        case 'MM/DD/YYYY HH:MM:SS':
            return month + "/" + date + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
        case 'MM-dd-YYYY HH:MM:SS':
            return month + "-" + date + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
        case 'MM-dd-YYYY HH:MM':
            return month + "-" + date + "-" + year + " " + hours + ":" + minutes;
        default:
            return new Date(timestamp);
    }
}

export const convertStringDateToLocalTimestamp = (date, format) => {
    if(!_.isEmpty(date)) {
        const timeStamp = Date.parse(date);
        return convertToLocalTimeStamp(timeStamp, format);
    }
}